import React from 'react';
import ListingProvider from './providers/Listing';
import ListingDetailSellerRouter from './ListingDetailSeller.router';

export default (props: any) => (
  <ListingProvider>
    <ListingDetailSellerRouter {...props} />
  </ListingProvider>
);
